import React, { useRef } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSmarkState, useKeycloakState } from "../Context/KeycloakContext";
import { CommonRoutes, RestrictedRoutes } from "./route-config";
import Loader from "react-loader-spinner";
import { toast } from "react-toastify";

const AppRoutes = () => {
  const { authenticated, kcInitialized } = useKeycloakState();
  const { userId } = useSmarkState();
  const isGlobalAdmin = JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

  
  const noPermissionToastShown = useRef(false);

  if (!kcInitialized) {
    return (
      <div className="spinner">
        <Loader type="Oval" color="#191f39" height={70} width={70} />
      </div>
    );
  }

  if (authenticated && !userId) {
    return (
      <div className="spinner">
        <Loader type="Oval" color="#191f39" height={70} width={70} />
      </div>
    );
  }

  const isLoggedIn = authenticated && userId;

  return (
    <Switch>
     
      {CommonRoutes.map((route, index) => {
        const { component: Component, ...rest } = route;
        return <Route {...rest} key={index} render={(props) => <Component {...props} />} />;
      })}

      
      {RestrictedRoutes.map((route, index) => {
        const { component: Component, requireGlobalAdmin, ...rest } = route;

        return (
          <Route
            {...rest}
            key={index}
            render={(props) => {
              if (!isLoggedIn) return <Redirect to="/" />;

              
              if (requireGlobalAdmin && !isGlobalAdmin) {
                if (!noPermissionToastShown.current) {
                  toast.error("You are not authorized to access the role management.");
                  noPermissionToastShown.current = true;
                }
                return <Redirect to="/dashboard" />;
              }

              const redirectUrl = sessionStorage.getItem("postLoginRedirect");
              if (redirectUrl) {
                sessionStorage.removeItem("postLoginRedirect");
                return <Redirect to={redirectUrl} />;
              }

              if (props.location.pathname === "/") {
                return <Redirect to="/dashboard" />;
              }

              return <Component {...props} />;
            }}
          />
        );
      })}

      {/* FALLBACK */}
      <Route
        path="*"
        render={() => {
          if (!isLoggedIn) return <Redirect to="/" />;

          const redirectUrl = sessionStorage.getItem("postLoginRedirect");
          if (redirectUrl) {
            sessionStorage.removeItem("postLoginRedirect");
            return <Redirect to={redirectUrl} />;
          }

          return <Redirect to="/dashboard" />;
        }}
      />
    </Switch>
  );
};

export default AppRoutes;
